import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';
import viewInquiryAdminQuery from './viewInquiryAdmin.graphql';
import s from './ViewInquiryAdmin.css'
import ViewInquiry from '../../../components/siteadmin/ViewInquiry/ViewInquiry';
import withStyles from 'isomorphic-style-loader/withStyles';
import { withQuery } from '../../../hoc/withGraphql';

class ViewInquiryRoutes extends Component {

    render() {
        const { viewInquiryAdmin: { viewInquiryAdmin, refetch }, id } = this.props;
        if (viewInquiryAdmin === null) {
            return <NotFound />
        }

        return (
            <div>
                <ViewInquiry
                    data={viewInquiryAdmin?.inquiries}
                    refetch={refetch}
                />
            </div>
        )
    }
};

export default compose(
    withStyles(s),
    withQuery(viewInquiryAdminQuery,
        {
            name: 'viewInquiryAdmin',
            options: (props) => ({
                variables: {
                    id: props?.id,
                },
                fetchPolicy: 'network-only',
                ssr: false
            })
        }),
)(ViewInquiryRoutes);